import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgClients = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-clients';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.14 3.279c-.624.078-1.101.319-1.581.8C5.002 4.636 4.76 5.218 4.76 6q.001 1.068.689 1.821c.445.484.901.748 1.52.875.389.081.673.081 1.062 0 .619-.127 1.075-.391 1.52-.875.757-.827.912-2.093.381-3.113-.214-.412-.726-.916-1.152-1.136a2.83 2.83 0 0 0-1.64-.293M15 5v.76h3.24V9h1.52V4.24H15zm-6.971-.126c.382.196.615.5.687.896.045.253.001.602-.102.802a1.5 1.5 0 0 1-.551.541c-.176.092-.25.106-.563.106s-.387-.014-.563-.106a1.5 1.5 0 0 1-.551-.541c-.155-.299-.155-.843-.002-1.141.137-.264.417-.501.731-.618.215-.08.703-.048.914.061M3.59 10.83l-1.11 1.111.53.529.531.53.879-.88.879-.88h4.402l.879.88.879.88.531-.53.53-.529-1.11-1.111-1.109-1.11H4.699zm12.55-.551c-.624.078-1.101.319-1.581.8-.557.557-.799 1.139-.799 1.921q.001 1.068.689 1.821c.445.484.901.748 1.52.875.389.081.673.081 1.062 0 .619-.127 1.075-.391 1.52-.875.757-.827.912-2.093.381-3.113-.214-.412-.726-.916-1.152-1.136a2.83 2.83 0 0 0-1.64-.293m.889 1.595c.382.196.615.5.687.896.045.253.001.602-.102.802a1.5 1.5 0 0 1-.551.541c-.176.092-.25.106-.563.106s-.387-.014-.563-.106a1.5 1.5 0 0 1-.551-.541c-.155-.299-.155-.843-.002-1.141.137-.264.417-.501.731-.618.215-.08.703-.048.914.061M4.24 17.38v2.38H9v-1.52H5.76V15H4.24zm8.35.45-1.11 1.111.53.529.531.53.879-.88.879-.88h4.402l.879.88.879.88.531-.53.53-.529-1.11-1.111-1.109-1.11h-5.602z"
    })
  }));
});
export default SvgClients;